//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GeneralTable from '@/components/GeneralTable';
import { log } from 'util';
import checkPermission from '@/utils/permission'; // 权限判断函数

export default {
  name: 'Index',
  components: {
    GeneralTable: GeneralTable
  },
  data: function data() {
    return {
      tableName: 't_position',
      moduleName: 'position_module',
      url: {
        getUrl: '/position',
        method: 'post',
        query: {}
      },
      canSearch: checkPermission('master.position.list'),
      //true,
      canAdd: checkPermission('master.position.add'),
      //true,
      canEdit: checkPermission('master.position.edit'),
      //true,
      canDelete: checkPermission('master.position.delete'),
      //true,
      canBatchEdit: checkPermission('master.position.batch'),
      //true,
      canImport: checkPermission('master.position.import_data'),
      canDownload: checkPermission('master.position.download') //true
    };
  },
  created: function created() {},
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 保存离开本页面时的查询条件，当再次进入本页面时回显
    if (this.$refs.GeneralTable) {
      sessionStorage.setItem(window.location.href + '_LIST_QUERY', JSON.stringify(this.$refs.GeneralTable.getListQuery()));
    }
    next();
  },
  methods: {}
};